module.exports = __webpack_public_path__ + "img/al.283b0ed.svg";